/* this is the same logic NuxtLink uses to prefetch a url (and its components) with some added guarding,
 * this allows us to use prefetching without using NuxtLink (as it cannot be extended / overwritten)
 * all (internal) links within an Article should use this logic (load more issues) */

const useLoadMoreNuxtLink = (to?: string) => {
  const pathId = `id${to?.replaceAll('/', '-')}`;
  const url = ref(to);

  // turn the NuxtLink into an internal (page) link.
  const onLoadMoreUpdate = () => {
    const elementById = document.getElementById(pathId);

    if (elementById && url.value !== `#${pathId}`) {
      url.value = decodeURIComponent(`#${pathId}`);
    }
  };

  onMounted(() => {
    document.addEventListener('load-more:update', onLoadMoreUpdate);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('load-more:update', onLoadMoreUpdate);
  });

  return { url };
};

export default useLoadMoreNuxtLink;
